import { useContext, useMemo } from "react";
import { AvisConstants } from "../../../../../data/avisConstants";
import { CreationBandInfo } from "../../../../../generated/data-contracts";
import { AvisSection } from "../../../../shared/components/form";
import {
  AvisSimpleTable,
  IColumnConfig,
} from "../../../../shared/components/table";
import { AvisContext } from "../../../../shared/context/AvisContext";

interface ICreationBandsProps {
  data: CreationBandInfo[] | undefined;
}

export function CreationBands(props: Readonly<ICreationBandsProps>) {
  const { res } = useContext(AvisContext);
  const { data } = props;
  const columnMetadata: IColumnConfig[] = useMemo(() => {
    return [
      {
        metadata: AvisConstants.table_default_column_metadata,
        type: "String",
        name: "entertainerOrGroup",
        translation: res("authors_Creation_Section_Bands_column_Title"),
      },
    ];
  }, [res]);
  if (!data) return; //Do not draw section if is not defined

  return (
    <AvisSection
      collapsable
      title={res("authors_Creation_Section_Bands_Title")}
      textToDisplayKey="portal_RH_CreationCard_Bands"
    >
      <AvisSimpleTable<CreationBandInfo>
        columnMetadata={columnMetadata}
        data={data}
      />
    </AvisSection>
  );
}
